import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: (data) => api.post('/api/auth/register', data),
  login: (data) => api.post('/api/auth/login', data),
  changePassword: (data) => api.post('/api/auth/change-password', data),
  forgotPassword: (data) => api.post('/api/auth/forgot-password', data),
  resetPassword: (data) => api.post('/api/auth/reset-password', data),
};

// User API
export const userAPI = {
  getProfile: () => api.get('/api/users/me'),
  updateAddress: (data) => api.patch('/api/users/me/address', data),
  updateProfile: (data) => api.patch('/api/users/me/profile', data),
  getFriendsShippingHere: () => api.get('/api/users/me/friends-shipping-here'),
};

// Admin API
export const adminAPI = {
  getUsers: (params) => api.get('/api/admin/users', { params }),
  getUserById: (userId) => api.get(`/api/admin/users/${userId}`),
  getUserLogs: (userId) => api.get(`/api/admin/users/${userId}/logs`),
  getEmailQueue: (params) => api.get('/api/admin/email-queue', { params }),
  updateUserRole: (userId, action) => api.post(`/api/admin/users/${userId}/role`, { user_id: userId, action }),
  updateUserProfile: (userId, data) => api.patch(`/api/admin/users/${userId}/profile`, data),
  getRecentChanges: (limit) => api.get('/api/admin/recent-changes', { params: { limit } }),
  deleteUser: (userId) => api.delete(`/api/admin/users/${userId}`),
  exportUsersCSV: () => api.get('/api/admin/users/export/csv', { responseType: 'blob' }),
};

export default api;
